// extracted by mini-css-extract-plugin
export default {"root":"Title_root__B4+TY","title":"Title_title__YZRGl","noIcon":"Title_noIcon__DA-uT","ques":"Title_ques__PQCX4","tips":"Title_tips__iQMZX"};